import { AccountInfoData, LspModuleData } from 'types';

/** Self-service farm invites in the user portal (onboarding step 2, Users page). */
export const FARM_USER_INVITE_UI_ENABLED = true;

const moduleName = (value?: string) => (value || '').trim().toLowerCase();

const isInviteEligibleModule = (module: LspModuleData) => {
  if (module.isActive === false) {
    return false;
  }

  const name = moduleName(module.name);
  const plan = moduleName(module.plan);

  if (!['vaxt', 'diko', 'slut', 'tavla'].includes(name)) {
    return false;
  }

  if (plan === 'trial') {
    return false;
  }

  if (module.endsAt) {
    const endsAt = new Date(module.endsAt);
    if (!Number.isNaN(endsAt.getTime()) && endsAt.getTime() <= Date.now()) {
      return false;
    }
  }

  return true;
};

export const canInviteFarmUsers = (accountInfo?: AccountInfoData): boolean => {
  if (!FARM_USER_INVITE_UI_ENABLED) {
    return false;
  }

  if (accountInfo?.canInviteFarmUsers === false) {
    return false;
  }

  if (accountInfo?.canInviteFarmUsers === true) {
    return true;
  }

  const modules = accountInfo?.allowedModules ?? [];

  if (!modules.length) {
    return true;
  }

  return modules.some(isInviteEligibleModule);
};
